export const SURVEY_LAUNCH_CONSTANTS = Object.freeze({
  FEOT: {
    CUSTOM_PACING: {
      DEFAULT_PACING_INTERVAL: 1,
      DEFAULT_PACING: 'days',
    },
  },
  MULTICOUNTRY: {
    CHECKBOX_BASED_SAME_SETTINGS_TEXT: {
      TRADITIONAL_VIEW: {
        URL_FEATURES: 'Use same Link to all locales',
        BILLING_ID_FEATURE: 'Use same Billing number to all locales',
        EMAIL_FEATURES: 'Use same Email Features to all locales',
      },
      SINGLE_VIEW: {
        URL_FEATURES: 'Use same Link to all locales',
        BILLING_ID_FEATURE: 'Use same Billing number to all locales',
        DATA_QUALITY_FEATURES: 'Use same Data quality Settings to all locales',
        LAUNCH_FEATURES: 'Use same Launch Settings to all locales',
        QUOTA_FEATURES: 'Use same Quota Features to all locales',
        FILTER_AUDIENCE_FEATURES: 'Use same Filter Audience to all locales',
        EMAIL_FEATURES: 'Use same Email Features to all locales',
      },
      UNIQUE_BUYER_ENTRY_LINKS: 'Use same File Links to all locales',
    },
    SAME_SETTINGS_TOOLTIP_TEXT: {
      SINGLE_VIEW:
        "Multi-country Single Survey doesn't allow different survey settings for each locale. Use Multi-country Multi Survey instead.",
    },
    AUTOMATIC_SAME_SETTINGS_TEXT: '(Automatically used to all surveys/locales)',
  },
  SURVEY: {
    PATCH_API: {
      PATH: {
        LIVE_URL: '/live_url',
        TEST_URL: '/test_url',
        BILLING_ID: '/billing_id',
        BUYER_PROJECT_MANAGER: '/bpm',
        OPERATOR_PROJECT_MANAGER: '/pm',
        CRM_ID: '/crmId',
        ASANA_ID: '/asanaId',
        SUBSCRIBER_EMAILS: '/subscriber_emails',
        PM_EMAILS: '/pm_emails',
        BUYER_MESSAGE: '/buyer_message',
      },
    },
  },
  ZAPPI_ALLOCATION_THROTTLING_COUNTRIES: ['US'],
});
